"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const school_services_1 = require("../../services/school.services");
exports.deleteAccount = (userApiEndPoint, fetchWitchCredential) => __awaiter(void 0, void 0, void 0, function* () {
    return yield fetchWitchCredential(`${userApiEndPoint}/users/me`, {
        method: 'delete'
    });
});
/**
 * Get school list
 * @param schoolType
 * @param value
 */
exports.getSchoolList = (schoolApiEndPoint, schoolType, value) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield fetch(`${schoolApiEndPoint}/search?schoolType=${schoolType}&limit=10&query=${value}`);
        if (response.ok) {
            const schoolList = (yield response.json());
            return schoolList.map(school_services_1.formatSchool);
        }
        return [];
    }
    catch (error) {
        return [];
    }
});
//# sourceMappingURL=profile.service.js.map